import { hasAppBadge } from './capabilities'

/**
 * Escreve o contador no ícone do app instalado.
 *
 * **No-op silencioso onde a API não existe, por contrato de plataforma**: BCD dá
 * `Navigator.setAppBadge.chrome_android: false`, e o Chrome documenta que no
 * Android o SO desenha o ponto sozinho quando há notificação não lida. Em desktop
 * Linux também não existe. Ausência aqui nunca é bug a investigar.
 *
 * Badge **não pede permissão** (P5): o Chrome diz "they don't need the user's
 * permission" e o WebKit aceita a chamada mesmo antes da permissão de notificação.
 * A MDN afirma o contrário; entre a doc e as duas implementações, o lado seguro é
 * tratar a promise como falível e ignorar a rejeição.
 *
 * Zero LIMPA em vez de escrever `0` — um badge com zero desenha um ponto vazio.
 */
export async function setAppBadgeCount(count: number): Promise<void> {
  if (!hasAppBadge()) return
  try {
    if (count > 0) await navigator.setAppBadge(count)
    else await navigator.clearAppBadge()
  } catch {
    /* ver P5 acima — rejeição aqui não muda nada que o usuário veja */
  }
}
